import $ from 'jquery';
import { resizeScroll } from '../core/ScrollService.js';
const initTabs = () => {
    if (document.querySelectorAll('.pSection--tabs .tabs')) {
        document.querySelectorAll('.pSection--tabs').forEach((sectionTabs) => {
            let tabsDOM = {
                labelsElt: sectionTabs.querySelector('.tabs_labels'),
                labels: sectionTabs.querySelectorAll('.tabs_labels button'),
                renderElt: sectionTabs.querySelectorAll('.tabs_render'),
                items: sectionTabs.querySelectorAll('.tabs_item')
            };

            tabsDOM.labels.forEach((elt) => {
                elt.addEventListener('click', (e) => {
                    e.preventDefault();
                    let index = elt.getAttribute('data-tab');

                    if (sectionTabs.querySelector('.tabs_labels .active')) {
                        sectionTabs.querySelector('.tabs_labels .active').classList.remove('active');
                    }
                    if (sectionTabs.querySelector('.tabs_item.active')) {
                        sectionTabs.querySelector('.tabs_item.active').classList.remove('active');
                    }

                    elt.classList.add('active');
                    sectionTabs.querySelector('.tabs_item[data-tab="' + index + '"]').classList.add('active');
                    resizeScroll();
                })
            });
        });
    }
};

export { initTabs };
